import * as types from '../actionType'

const initialState = []

export const category = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_CATEGORY:
            return action.payload
        default:
            return state
    }
}